/**
 * GENERATED FILE — do not hand-edit.
 *
 * Mirrors the vendored HackerNoon pixel-icon-library in `public/icons/`.
 * Regenerate with:
 *
 *   node -e "…" (see docs/ARCHITECTURE.md, subsystem F report)
 *
 * The unions exist so a typo in an icon id fails `npm run typecheck` instead of
 * rendering an empty box at runtime. 248 solid, 248 regular.
 */

export const SOLID_ICON_NAMES = [
  "ad",
  "align-center",
  "align-justify",
  "align-left",
  "align-right",
  "analytics",
  "angle-down",
  "angle-left",
  "angle-right",
  "angle-up",
  "archive",
  "arrow-alt-circle-down",
  "arrow-alt-circle-left",
  "arrow-alt-circle-right",
  "arrow-alt-circle-up",
  "arrow-circle-down",
  "arrow-circle-left",
  "arrow-circle-right",
  "arrow-circle-up",
  "arrow-down",
  "arrow-left",
  "arrow-right",
  "arrow-up",
  "at",
  "badge-check",
  "bank",
  "bars",
  "bell",
  "bell-exclaimation",
  "bell-mute",
  "bold",
  "bolt",
  "book",
  "book-bookmark",
  "book-heart",
  "bookmark",
  "box-heart",
  "box-usd",
  "bracket-curly",
  "bracket-round",
  "bracket-square",
  "branch",
  "briefcase",
  "brightness-high",
  "brightness-low",
  "broom",
  "bug",
  "bullet-list",
  "bullhorn",
  "calendar-alt",
  "calender",
  "camera",
  "cart-add",
  "cart-minus",
  "cassette-tape",
  "cc",
  "chart-line",
  "chart-network",
  "check",
  "check-box",
  "check-circle",
  "check-list",
  "chevron-down",
  "chevron-up",
  "circle-notch",
  "clipboard",
  "clock",
  "cloud-download",
  "cloud-fog",
  "cloud-rain",
  "cloud-upload",
  "code",
  "code-block",
  "cog",
  "coin",
  "coins",
  "collapse",
  "command",
  "comment",
  "comment-dots",
  "comment-quote",
  "comments",
  "copy",
  "credit-card",
  "crown",
  "disc",
  "divider",
  "dollar",
  "door-closed",
  "door-open",
  "download",
  "download-alt",
  "edit",
  "ellipses-horizontal",
  "ellipses-horizontal-circle",
  "ellipses-vertical",
  "ellipses-vertical-circle",
  "envelope",
  "exclaimation",
  "exclamation-triangle",
  "expand",
  "external-link",
  "eye",
  "eye-cross",
  "eye-snake",
  "face-angry",
  "face-grin",
  "face-heart-eyes",
  "face-laugh-squint",
  "face-sad",
  "face-thinking",
  "file-import",
  "filter",
  "filter-alt-circle",
  "fire",
  "flag",
  "flag-checkered",
  "folder",
  "folder-open",
  "fork",
  "glasses",
  "globe",
  "globe-americas",
  "graduation-cap",
  "grid",
  "handshake",
  "hashtag",
  "heading-1",
  "heading-2",
  "heading-3",
  "headphones",
  "heart",
  "highlight",
  "hockey-mask",
  "home",
  "image",
  "indent",
  "info-circle",
  "italics",
  "laptop",
  "laptop-code",
  "lightbulb",
  "line-height",
  "link",
  "location-pin",
  "lock",
  "lock-alt",
  "lock-open",
  "login",
  "logout",
  "medical-house",
  "merge",
  "message",
  "message-dots",
  "minus",
  "moon",
  "music",
  "newspaper",
  "notebook",
  "numbered-list",
  "octagon-check",
  "octagon-times",
  "outdent",
  "page-break",
  "paint-brush",
  "paperclip",
  "paragraph",
  "pause",
  "pc",
  "pen",
  "pen-nib",
  "pencil",
  "pencil-ruler",
  "people-carry",
  "phone-ringing-high",
  "phone-ringing-low",
  "plane",
  "plane-departure",
  "play",
  "playlist",
  "plus",
  "print",
  "pro",
  "pull-request",
  "question",
  "question-circle",
  "quote-left",
  "quote-right",
  "receipt",
  "refresh",
  "retro-camera",
  "retro-pc",
  "robot",
  "save",
  "search",
  "seedlings",
  "shapes",
  "share",
  "share-alt",
  "shop",
  "shopping-cart",
  "shuffle",
  "side-nav-collapse",
  "side-nav-expand",
  "sitemap",
  "sort",
  "sound-mute",
  "sound-on",
  "sparkles",
  "spinner",
  "spinner-third",
  "star",
  "star-crescent",
  "strike-through",
  "sun",
  "table",
  "tag",
  "text-slash",
  "themes",
  "thumbsdown",
  "thumbsup",
  "thumbtack",
  "times",
  "times-circle",
  "times-square",
  "translate",
  "trash",
  "trash-alt",
  "trending",
  "trophy",
  "underline",
  "unlock",
  "unlock-alt",
  "upload",
  "upload-alt",
  "user",
  "user-check",
  "user-headset",
  "user-minus",
  "user-plus",
  "users",
  "users-crown",
  "video-camera",
  "vote-yeah",
  "wallet",
  "wifi",
  "window-close",
  "window-restore",
] as const;

export const REGULAR_ICON_NAMES = [
  "ad",
  "align-center",
  "align-justify",
  "align-left",
  "align-right",
  "analytics",
  "angle-down",
  "angle-left",
  "angle-right",
  "angle-up",
  "archive",
  "arrow-alt-circle-down",
  "arrow-alt-circle-left",
  "arrow-alt-circle-right",
  "arrow-alt-circle-up",
  "arrow-circle-down",
  "arrow-circle-left",
  "arrow-circle-right",
  "arrow-circle-up",
  "arrow-down",
  "arrow-left",
  "arrow-right",
  "arrow-up",
  "at",
  "badge-check",
  "bank",
  "bars",
  "bell",
  "bell-exclaimation",
  "bell-mute",
  "bold",
  "bolt",
  "book",
  "book-bookmark",
  "book-heart",
  "bookmark",
  "box-heart",
  "box-usd",
  "bracket-curly",
  "bracket-round",
  "bracket-square",
  "branch",
  "briefcase",
  "brightness-high",
  "brightness-low",
  "broom",
  "bug",
  "bullet-list",
  "bullhorn",
  "calendar-alt",
  "calender",
  "camera",
  "cart-add",
  "cart-minus",
  "cassette-tape",
  "cc",
  "chart-line",
  "chart-network",
  "check",
  "check-box",
  "check-circle",
  "check-list",
  "chevron-down",
  "chevron-up",
  "circle-notch",
  "clipboard",
  "clock",
  "cloud-download-alt",
  "cloud-fog",
  "cloud-rain",
  "cloud-upload",
  "code",
  "code-block",
  "cog",
  "coin",
  "coins",
  "collapse",
  "command",
  "comment",
  "comment-dots",
  "comment-quote",
  "comments",
  "copy",
  "credit-card",
  "crown",
  "disc",
  "divider",
  "dollar",
  "door-closed",
  "door-open",
  "download",
  "download-alt",
  "edit",
  "ellipses-horizontal",
  "ellipses-horizontal-circle",
  "ellipses-vertical",
  "ellipses-vertical-circle",
  "envelope",
  "exclaimation",
  "exclamation-triangle",
  "expand",
  "external-link",
  "eye",
  "eye-cross",
  "eye-snake",
  "face-angry",
  "face-grin",
  "face-heart-eyes",
  "face-laugh-squint",
  "face-sad",
  "face-thinking",
  "file-import",
  "filter",
  "filter-alt-circle",
  "fire",
  "flag",
  "flag-checkered",
  "folder",
  "folder-open",
  "fork",
  "glasses",
  "globe",
  "globe-americas",
  "graduation-cap",
  "grid",
  "h1",
  "h2",
  "h3",
  "handshake",
  "hashtag",
  "headphones",
  "heart",
  "highlight",
  "hockey-mask",
  "home",
  "image",
  "indent",
  "info-circle",
  "italics",
  "laptop",
  "laptop-code",
  "lightbulb",
  "line-height",
  "link",
  "location-pin",
  "lock",
  "lock-alt",
  "lock-open",
  "login",
  "logout",
  "medical-house",
  "merge",
  "message",
  "message-dots",
  "minus",
  "moon",
  "music",
  "newspaper",
  "notebook",
  "numbered-list",
  "octagon-check",
  "octagon-times",
  "outdent",
  "page-break",
  "paint-brush",
  "paperclip",
  "paragraph",
  "pause",
  "pc",
  "pen",
  "pen-nib",
  "pencil",
  "pencil-ruler",
  "people-carry",
  "phone-ringing-high",
  "phone-ringing-low",
  "plane",
  "plane-departure",
  "play",
  "playlist",
  "plus",
  "print",
  "pro",
  "pull-request",
  "question",
  "question-circle",
  "quote-left",
  "quote-right",
  "receipt",
  "refresh",
  "retro-camera",
  "retro-pc",
  "robot",
  "save",
  "search",
  "seedlings",
  "shapes",
  "share",
  "share-alt",
  "shop",
  "shopping-cart",
  "shuffle",
  "side-nav-collapse",
  "side-nav-expand",
  "sitemap",
  "sort",
  "sound-mute",
  "sound-on",
  "sparkles",
  "spinner",
  "spinner-third",
  "star",
  "star-crescent",
  "strike-through",
  "sun",
  "table",
  "tag",
  "text-slash",
  "themes",
  "thumbsdown",
  "thumbsup",
  "thumbtack",
  "times",
  "times-circle",
  "times-square",
  "translate",
  "trash",
  "trash-alt",
  "trending",
  "trophy",
  "underline",
  "unlock",
  "unlock-alt",
  "upload",
  "upload-alt",
  "user",
  "user-check",
  "user-headset",
  "user-minus",
  "user-plus",
  "users",
  "users-crown",
  "video-camera",
  "vote-yeah",
  "wallet",
  "wifi",
  "window-close",
  "window-restore",
] as const;

/** Every id in `public/icons/solid`. This is the canonical UI icon vocabulary. */
export type SolidIconName = (typeof SOLID_ICON_NAMES)[number];

/** Every id in `public/icons/regular`. Six ids differ from the solid set. */
export type RegularIconName = (typeof REGULAR_ICON_NAMES)[number];

export const SOLID_ICON_SET: ReadonlySet<string> = new Set(SOLID_ICON_NAMES);
export const REGULAR_ICON_SET: ReadonlySet<string> = new Set(REGULAR_ICON_NAMES);
